import Components from "../components";

class ControlSection extends Components.Base {
  bind() {
    this.on("change", "[data-enable]", this.toggleControls);
    this.$el.find("[data-enable]").trigger("change");
  }

  unbind() {
    this.$el.off("change", this.toggleControls);
  }

  toggleControls(e) {
    const $target = $(e.currentTarget);
    const $container = $target.parents(".c-control-section");
    const $controls = $($container.find($target.attr("data-enable")));
    $controls.attr("disabled", !$target.is(":checked"));
  }
}

Components.collection.register({
  selector: ".c-control-section",
  klass: ControlSection,
});
